<template>
  <v-navigation-drawer
    app
    :width="220"
    :mini-variant="miniVariant"
    v-model="sidebarActive"
    id="sidebar">
    <v-img id="panelLogo" :src="'/static/Iceverg_logo.png'" width="inherit" style="min-height: 64px"></v-img>
    <!-- -->
    <v-list>
      <template v-for="(option, key) in sidebarOptions">
        <router-link :to="option.path" v-if="option.items === null" :key="`${option.path}-${option.active}`">
          <v-list-item :class="option.active ? 'selected':''" @click="sidebarPath(option.path)">
            <v-list-item-content>
              <v-list-item-title>
                <v-icon class="mr-3">{{option.icon}}</v-icon>
                <span>{{option.name}}</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
        <template v-else>

          <v-list-group
            :prepend-icon="option.icon"
            :value="option.active"

          >
            <template v-slot:activator>
              <v-list-item-title>{{option.name}}</v-list-item-title>
            </template>
            <router-link v-for="(item, k) in option.items" :to="item.path" :key="`${item.path}-${item.active}`">
              <v-list-item :class="item.active ? 'selected':''" @click="sidebarPath(item.path)">
                <v-list-item-icon>
                  <v-icon small class="mx-3">{{item.icon}}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  {{item.name}}
                </v-list-item-title>
              </v-list-item>
            </router-link>
          </v-list-group>

        </template>
      </template>

      <v-list-item>
        <a href="https://lp.iceverg.com/100-ideas-para-fidelizar" target="_blank">
          <v-list-item-content>
            <v-list-item-title>
              <v-icon class="mr-3">mdi-lightbulb-outline</v-icon>
              <span>Tips</span>
            </v-list-item-title>
          </v-list-item-content>
        </a>

      </v-list-item>

    </v-list>
    <template v-slot:append>
      <div class="pr-3 pb-3 text-right">
        <v-btn fab bottom depressed right x-small @click="miniVariant = !miniVariant" v-if="!miniVariant">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn fab bottom depressed right x-small @click="miniVariant = !miniVariant" v-else>
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "icevergSidebar",
    data() {
      return {
        miniVariant: false,
        drawer: true
      }
    },
    computed: {

      ...mapGetters(['sidebarOptions']),
      // sidebarOptions() {
      //   console.log('computed' ,this.$store.getters.sidebarOptions);
      //   return this.$store.getters.sidebarOptions;
      // },
      sidebarActive: {
        get() {
          return this.$store.getters.sidebarActive;
        },
        set(val) {
          this.$store.dispatch("toggleSidebar", val);
        }
      },


    },
    mounted() {
      this.$store.dispatch('setActiveMenuGroup', {pathURL: this.$router.currentRoute.path});
    },
    methods: {
      isActive(active) {
        return active ? 'selected' : '';
      },
      sidebarPath(link) {
        setTimeout(() => {
          this.$store.dispatch('setActiveMenuGroup', {pathURL: link});
        }, 100);
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Sidebar/icevergSidebar.vue